<div class="flex-col start-start gap-24 speakers">
  <div class="flex-row start-center narrower-input">
    <ui-search [placeholder]="'SPEAKERS.SEARCH'|translate"  (onInput)="search($event)">

    </ui-search>
  </div>
  <div class="speakers-table w-100">
    <table
      mat-table
      [dataSource]="query ? filtered(speakers) :  speakers"
      class="ui-table"
      matSort
      matSortActive="name"
      matSortDisableClear
      matSortDirection="desc"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [sortActionDescription]="'SPEAKERS.SORT_BY_NAME'|translate"
        >
          {{ 'SPEAKERS.NAME'|translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="model">
        <th mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [sortActionDescription]="'SPEAKERS.SORT_BY_BRAND'|translate"
        >
          {{ 'SPEAKERS.MODEL'|translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.model || 'N/A' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ipAddress">
        <th mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [sortActionDescription]="'SPEAKERS.SORT_BY_MAC'|translate"
        >
          {{ 'SPEAKERS.IP_ADDRESS_URL'|translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.ipAddress }} {{ row.sipUrl }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row" class="hover">
          <div class="flex-row end-center gap-8 actions svg-fill-gray-600 icon-16">
            @if (row.model === SpeakerBrands.SIP) {
              <span
                [matTooltip]="'COMMON.MANAGE_CAMERAS'|translate"
                (click)="selectCamera(row)"
                class="ui-icon-add-camera ui-icon-button"
              ></span>
            }
            <span
              [matTooltip]="'COMMON.EDIT'|translate"
              (click)="edit(row)" class="ui-icon-edit ui-icon-button no-border"
            ></span>
            <span
              [matTooltip]="'COMMON.DELETE'|translate"
              (click)="delete(row)" class="ui-icon-delete ui-icon-button no-border"
            ></span>
          </div>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
